import httpApi from './api/httpApi';
import useSWR from 'swr';

const DEFAULT_STOCK_URL = '/api/v1/payment-methods';

export const usePaymentOptionsSWR = () => {
    const fetchStock = (query): Promise<PaymentOption[]> => {
        return httpApi
            .get<{ payment_methods: PaymentOption[] }>(query)
            .then((res) => {
                return res.getData().payment_methods;
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(
        DEFAULT_STOCK_URL,
        fetchStock,
        {
            dedupingInterval: 600000, // 10min
            errorRetryCount: 3,
        }
    );

    return {
        payments: data ? data : null,
        isLoadingPayments: isLoading,
        isErrorPayments: error,
        forceRefreshPayments: mutate,
    };
};

export default usePaymentOptionsSWR;

interface PaymentOption {
    code: string;
    description: string;
}
